export const CARD_SENSITIVE_BY_ID = {
  main: {
    pan: '5852 6495 4853 9667',
    expiry: '05/28',
    cvv: '123',
  },
  travel: {
    pan: '4111 2245 8890 2245',
    expiry: '08/27',
    cvv: '456',
  },
  savings: {
    pan: '5100 7790 1122 7790',
    expiry: '11/29',
    cvv: '789',
  },
  user: {
    pan: '5852 6495 4853 9667',
    expiry: '05/28',
    cvv: '123',
  },
};

export function getSensitiveData(cardId) {
  return CARD_SENSITIVE_BY_ID[cardId] ?? CARD_SENSITIVE_BY_ID.main;
}

export function formatMaskedPan(lastFour) {
  return `••••  ••••  ••••  ${lastFour}`;
}

export function getCardStyleName(style, localizedStyles = {}) {
  const styleKey = style || 'sunset';
  return localizedStyles[styleKey] || styleKey.charAt(0).toUpperCase() + styleKey.slice(1);
}
